import React from "react";
import Header from "../header";
import ProductCatSection from "./productCategories";
import ProductListSection from "./productList";
import styles from "./productsStyles.module.css";

function Products() {
  return (
    <div>
      <Header />
      <main id={styles.productsMain}>
        <ProductListSection />
        <ProductCatSection />
      </main>
    </div>
  );
}

export default Products;
